import React from 'react'
import { Field } from '../../form'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
// import { removePassengerRow } from '../../actions'
import FontAwesome from 'react-fontawesome'
import { Translation } from 'react-i18next'
import mobileView from '../../utils/mobile.utils'

const styles = (theme) => ({
  tablecell: {
    padding: 0,
    borderBottom: 0
  },
  textField: {
    marginTop: theme.spacing(3),
    minWidth: 190,
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif',
    width: '100%'
  },
  resize: {
    fontSize: '14px'
  },
  margin: {
    marginTop: 40,
    float: 'right'
  }
})

const AllowancePassenger = ({
  classes,
  index,
  remove,
  control,
  addingRow,
  setAddingRow,
  isReadOnly
}) => {
  React.useEffect(() => {
    if (addingRow) {
      setAddingRow(false)
    }
  }, [addingRow, setAddingRow])

  return (
    <Translation>
      {(t) => {
        return (
          <TableRow className="dashboard-invoice-inputrow">
            <TableCell className={classes.tablecell}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '0px'
                }}
              >
                <div
                  style={{
                    maxWidth: mobileView ? '100%' : '480px',
                    width: '100%'
                  }}
                >
                  <Field
                    name={`allowancePassenger.${index}.passenger`}
                    inputType="textfield"
                    control={control}
                    className={classNames(classes.textField, classes.resize)}
                    disabled={isReadOnly}
                    label={t('NewPassenger.label')}
                    autoFocus={addingRow}
                  />
                </div>

                <IconButton
                  aria-label="Delete"
                  className={classes.margin}
                  onClick={() => remove(index)}
                  key={index}
                  disabled={isReadOnly}
                >
                  <FontAwesome
                    name="window-close"
                    style={{
                      width: '100%',
                      color: isReadOnly ? 'Gray' : '#F67131',
                      opacity: isReadOnly ? 0.7 : 1
                    }}
                  />
                </IconButton>
              </div>
            </TableCell>
          </TableRow>
        )
      }}
    </Translation>
  )
}

AllowancePassenger.propTypes = {
  classes: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  remove: PropTypes.func.isRequired,
  control: PropTypes.object.isRequired,
  addingRow: PropTypes.bool.isRequired,
  setAddingRow: PropTypes.func.isRequired
}

export default withStyles(styles)(AllowancePassenger)
